// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes _1v8p5el2 {
  0% {
    width: 40px;
  }
  100% {
    width: auto;
    min-width: 200px;
    max-width: 300px;
  }
}
._1v8p5el0 {
  position: sticky;
  display: flex;
  justify-content: center;
  top: 100px;
  z-index: var(--_18w76bw4u);
}
._1v8p5el1 {
  display: flex;
  width: 100%;
  position: absolute;
  top: 10px;
  gap: 10px;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
}
._1v8p5el3 {
  border-radius: 36px;
  padding: 8px 16px 8px 8px;
  gap: 16px;
  background: #fff;
  border: 1px solid #DBDBDB;
  pointer-events: auto;
  overflow: hidden;
  white-space: nowrap;
  box-shadow: 0px 4px 18px 0px #00000040;
}
._1v8p5el4 {
  animation: _1v8p5el2 2s forwards;
}
._1v8p5el5 {
  animation: _1vsx45w1 0.5s linear forwards;
}
._1v8p5el6 {
  background-color: transparent;
  flex-shrink: 0;
}
._1v8p5el7 {
  opacity: 0;
  animation: _1vsx45w0 0.5s linear 0.25s forwards;
}
._1v8p5el8 {
  opacity: 0;
  animation: _1vsx45w0 1s linear 1s forwards;
}
@media screen and (min-width: 768px) {
  ._1v8p5el0 {
    top: 0;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;AACF;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,UAAU;EACV,+CAA+C;AACjD;AACA;EACE,UAAU;EACV,0CAA0C;AAC5C;AACA;EACE;IACE,MAAM;EACR;AACF","sourcesContent":["@keyframes _1v8p5el2 {\n  0% {\n    width: 40px;\n  }\n  100% {\n    width: auto;\n    min-width: 200px;\n    max-width: 300px;\n  }\n}\n._1v8p5el0 {\n  position: sticky;\n  display: flex;\n  justify-content: center;\n  top: 100px;\n  z-index: var(--_18w76bw4u);\n}\n._1v8p5el1 {\n  display: flex;\n  width: 100%;\n  position: absolute;\n  top: 10px;\n  gap: 10px;\n  flex-direction: column;\n  align-items: center;\n  pointer-events: none;\n}\n._1v8p5el3 {\n  border-radius: 36px;\n  padding: 8px 16px 8px 8px;\n  gap: 16px;\n  background: #fff;\n  border: 1px solid #DBDBDB;\n  pointer-events: auto;\n  overflow: hidden;\n  white-space: nowrap;\n  box-shadow: 0px 4px 18px 0px #00000040;\n}\n._1v8p5el4 {\n  animation: _1v8p5el2 2s forwards;\n}\n._1v8p5el5 {\n  animation: _1vsx45w1 0.5s linear forwards;\n}\n._1v8p5el6 {\n  background-color: transparent;\n  flex-shrink: 0;\n}\n._1v8p5el7 {\n  opacity: 0;\n  animation: _1vsx45w0 0.5s linear 0.25s forwards;\n}\n._1v8p5el8 {\n  opacity: 0;\n  animation: _1vsx45w0 1s linear 1s forwards;\n}\n@media screen and (min-width: 768px) {\n  ._1v8p5el0 {\n    top: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
